<!-- <p>date-range-picker works!</p> -->
<!-- <div style="margin: 1em;"> -->
    <ejs-daterangepicker class="calendar" placeholder="'Pick a date range..." format="dd/MM/yyyy" [max]="today"
        [presets]="datePickerPresets" (click)="$event.stopPropagation()"
        (change)="datePickerChange.emit($event)"></ejs-daterangepicker>
<!-- </div> -->